// extracted by mini-css-extract-plugin
export default {"main":"PLinkItem_main__rkEcJ","content":"PLinkItem_content__LEXYc","title":"PLinkItem_title__0P3-d","itemsCont":"PLinkItem_itemsCont__BIK2+"};